// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__36S_j","footer":"ModalError_footer__3qMh1"};